import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  maintenanceList: {},
  maintenanceById: {},
  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    deleteImage : false
  },
  error: false,
  errorMessage: "",
};

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    getMaintenanceList(state, action) {
      state.maintenanceList = action.payload;
      state.loading.read = false;
      state.error = null;
    },
    maintenanceByIdData(state, action) {
      state.maintenanceById = action.payload;
      state.loading.getById = false;
      state.error = null;
    },
    errorMessages(state, action) {
      state.errorMessage = action.payload;
      state.error = true;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    loadingData(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getMaintenanceList,
  maintenanceByIdData,
  errorMessages,
  loadingData,
  hideErrorMessage,
} = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
